import styled from 'styled-components';

const FooterSegment = styled.section`
  /* margin-top:113px; */
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    position: relative;
  };
  .copyrights{
    font-size: 12px;
    padding: 20px 0px;
    margin: 0px;
    font-weight: normal;
    text-align: center;
    background: linear-gradient(180deg, rgba(234,236,244,1) 0%, rgba(255,255,255,1) 100%) no-repeat;
    ul{
    margin:0px;
    padding:0px;
    list-style:none;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    li{
      margin:0px;
      a{
        &:hover{
          color: ${(props) => props.theme.primaryLight};
        }
      }
    }
  }
  }
  .clr-black{
    color: ${(props) => props.theme.LandingBlack};
    &:hover{
      color: ${(props) => props.theme.primaryColor};
    }
  }
`;

export default FooterSegment;



// WEBPACK FOOTER //
// client/components/FooterSegment/index.js